import axios from "axios";
import { APP_URL } from "../../config/api";
import { errorMessage } from "../errorHandle";

export const getTrainerList = (cred) => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-trainer-list`,
        data:cred
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.GET_TRAINER_LIST,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

export const createTakeCall = (cred) => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/create-take-call`,
        data: cred
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.CREATE_TAKE_CALL,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

export const showTakeCall = () => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/show-take-call`
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.SHOW_TAKE_CALL,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

export const showTakeCallDetails = (cred) => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/show-take-call-details`,
        data: cred
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.SHOW_TAKE_CALL_DETAILS,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

export const assingTrainerToTraining = (cred) => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/assign-trainer-to-training`,
        data: cred
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.ASSIGN_TRAINER_TO_TRAINING,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

export const rescheduleTakeCall = (cred) => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/reschedule-take-call`,
        data: cred
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.RESCHEDULE_TAKE_CALL,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

export const trainerTakeCallList = (cred) => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/trainer-take-calls`,
        data: cred
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.TRAINER_TAKE_CALLS,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

export const reScheduletrainerTakeCall = (cred) => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/reschedule-trainer-take-call`,
        data: cred
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.RESCHEDULE_TRAINER_TAKE_CALL,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

export const getTrainingRequirements = (cred) => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-training-requirements`,
        data: cred
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.GET_TRANING_REQUIREMENT,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

export const getTrainingTrainerRequirementStatus = (cred) => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-training-trainers-requirement-status`,
        data: cred
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.GET_TRANING_TRAINER_REQUIREMENT_STATUS,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

export const updateTrainingRequirement = (cred) => {
  return (dispatch) => {
    dispatch({
      type: ASSIGN_TRAINER.REQUEST
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/update-training-requirement`,
        data: cred
      })
      .then((res) => {
        dispatch({
          type: ASSIGN_TRAINER.UPDATE_TRAINER_TRANING_REQUIREMENT,
          payload: res.data
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, ASSIGN_TRAINER.ERROR));
      });
  };
};

const TAG = "ASSIGN_TRAINER";

export const ASSIGN_TRAINER = {
  ERROR: TAG + "ERROR",
  REQUEST: TAG + "REQUEST",
  GET_TRAINER_LIST: TAG + "GET_TRAINER_LIST",
  CREATE_TAKE_CALL: "CREATE_TAKE_CALL",
  SHOW_TAKE_CALL: TAG + "SHOW_TAKE_CALL_TRAINING",
  SHOW_TAKE_CALL_DETAILS: TAG + "SHOW_TAKE_CALL_DETAILS",
  ASSIGN_TRAINER_TO_TRAINING: TAG + "ASSIGN_TRAINER_TO_TRAINING",
  RESCHEDULE_TAKE_CALL: TAG + "RESCHEDULE_TAKE_CALL",
  TRAINER_TAKE_CALLS: TAG + "TRAINER_TAKE_CALLS",
  RESCHEDULE_TRAINER_TAKE_CALL: TAG + "RESCHEDULE_TRAINER_TAKE_CALL",
  GET_TRANING_REQUIREMENT: TAG + "GET_TRANING_REQUIREMENT",
  UPDATE_TRAINER_TRANING_REQUIREMENT:
    TAG + "UPDATE_TRAINER_TRANING_REQUIREMENT",
  GET_TRANING_TRAINER_REQUIREMENT_STATUS:
    TAG + "GET_TRANING_TRAINER_REQUIREMENT_STATUS"
};
